import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {useRecipe} from '@chakra-ui/react3'
import {hasValidString} from '../../../utils/utils'
import copyRecipe from './index.recipe'
import RichText from '../rich-text'

/**
 * Displays a text block with optional alignment and variant.
 * Intended for use from leap modules as a top level component. Should not be used by module children.
 * If needed extend the variants.
 * The purpose is to have all uses of the module level copy at a single place.
 *
 * @component
 * @param {Object} props - Component properties.
 * @param {'left'|'center'|'inherit'} [props.alignment='left'] - Horizontal alignment of the text, could be used a chakra breakpoint object
 * @param {string} props.text - The text content to display.
 * @param {'default'|'hero'|'gallery'|'newsletter'|'contentTeaser'|'contentTeaserOnMedia'} [props.variant='default'] - Visual variant for module-level copy styling
 * @returns {JSX.Element} Rendered text element.
 */

const Copy = ({alignment = 'left', text, variant = 'default'}) => {
    const recipe = useRecipe({recipe: copyRecipe})
    const styles = useMemo(() => recipe({alignment, variant}), [recipe, alignment, variant])

    if (!hasValidString(text)) return null

    return <RichText css={styles}>{text}</RichText>
}

Copy.propTypes = {
    alignment: PropTypes.oneOf(['left', 'center', 'inherit']),
    text: PropTypes.string,
    variant: PropTypes.oneOf([
        'default',
        'hero',
        'gallery',
        'newsletter',
        'contentTeaser',
        'contentTeaserOnMedia'
    ])
}

export default Copy
